/* eslint-disable no-unused-vars */

import _ from 'lodash';

import { createSlice } from '@reduxjs/toolkit';
import { getDistance } from '@utilities/get-distance';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';

const initialState = {
  unit: '',
  loading: true,
  pendingSync: 0,
  prevPendingSync: 0,
  coordinates: null,
  locationUpdateTime: null,
  sites: [],
  sitesMap: {},
  sitesLoading: true,
  equipments: [],
  equipmentsMap: {},
  sitesEquipmentsMap: {},
  equipmentsLoading: false,
  caching: false,
  cachingComplete: false,
  cachingFailure: false,
  isSyncing: false,
  isSyncingModal: false,
  workOrderInspectionsAndChecksIsSync: false,
  syncedNewAndEditedEquipments: [],

  sitesWithoutMobile: [],
  sitesWithoutMobileMap: {},
  equipmentsWithoutMobile: [],
  equipmentsWithoutMobileMap: {},
  equipmentsCache: [],
  equipmentsCacheMap: {},
  equipmentElectrical: [],
  equipmentElectricalMap: {},
  equipmentPsvs: [],
  equipmentPsvsMap: {},
  equipmentPumpJacks: [],
  equipmentPumpJacksMap: {},
  equipmentVehicles: [],
  equipmentVehiclesMap: {},
  refreshingAndSyncingData: true,
  syncReminder: false,
  lastSuccessFullRefreshTime: '',
  startTaskCoordinates: {},
  routes: [],
  currentTaskId: '',
  disabledCancelButtonOnRefresh: false,
  equipmentListThatHaveUTSection: []
};

export const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setDisabledCacheButtonOnRefresh: (state, action) => {
      state.disabledCancelButtonOnRefresh = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCurrentTaskId: (state, action) => {
      state.currentTaskId = action.payload;
    },
    setWorkOrderInspectionsAndChecksIsSync: (state, action) => {
      state.workOrderInspectionsAndChecksIsSync = action.payload;
    },
    setSitesLoading: (state, action) => {
      state.sitesLoading = action.payload;
    },
    startCaching: (state) => {
      state.caching = true;
      state.cachingComplete = false;
      state.cachingFailure = false;
      localStorage.setItem('cachingFailure', false);
    },
    completeCaching: (state) => {
      state.caching = false;
      state.cachingComplete = true;
      state.cachingFailure = false;
    },
    failureCaching: (state) => {
      state.caching = false;
      state.cachingComplete = false;
      state.cachingFailure = true;
      localStorage.setItem('cachingFailure', true);
    },
    setLastSuccessFullRefreshTime: (state, action) => {
      state.lastSuccessFullRefreshTime = action.payload;
    },
    closeCachingComplete: (state) => {
      state.caching = false;
      state.cachingComplete = false;
      state.cachingFailure = false;
    },
    updateSyncing: (state, action) => {
      state.isSyncing = action.payload;
    },
    updateSyncingModal: (state, action) => {
      state.isSyncingModal = action.payload;
    },
    updateSyncingReminder: (state, action) => {
      state.syncReminder = action.payload;
    },
    updateRefreshingAndSyncingData: (state, action) => {
      state.refreshingAndSyncingData = action.payload;
    },
    setUnitAndCoordinates: (state, action) => {
      const { unit, coordinates, locationUpdateTime } = action.payload;
      state.unit = unit;
      state.coordinates = coordinates;
      state.locationUpdateTime = locationUpdateTime;
    },

    setNewUnit: (state, action) => {
      const { unit } = action.payload;
      state.unit = unit;
    },
    setPendingSync: (state, action) => {
      state.pendingSync = action.payload;
    },
    setPrevPendingSync: (state, action) => {
      state.prevPendingSync = action.payload;
    },
    setSitesMobile: (state, action) => {
      const { sites, sitesMap } = sitesMobileData(action.payload || state.sites || [], state);
      state.sites = sites;
      state.sitesMap = sitesMap;
      if (action.payload) state.sitesLoading = false;
    },
    setSitesMobile1: (state, action) => {
      const { sites, sitesMap } = action.payload;
      state.sites = sites;
      state.sitesMap = sitesMap;
    },
    setEquipments: (state, action) => {
      const {
        equipments,
        equipmentsMap,
        sitesEquipmentsMap,
        equipmentListThatHaveUTSection = [],
        noChangeOnUT = false
      } = action.payload || {};
      state.equipments = equipments;
      state.equipmentsLoading = false;
      state.equipmentsMap = equipmentsMap;
      state.sitesEquipmentsMap = sitesEquipmentsMap;
      if (!noChangeOnUT) state.equipmentListThatHaveUTSection = equipmentListThatHaveUTSection;
      else state.equipmentListThatHaveUTSection = state.equipmentListThatHaveUTSection || [];
    },

    setSyncedEquipments: (state, action) => {
      state.syncedNewAndEditedEquipments = action.payload || [];
    },
    deleteEquipment: (state, action) => {
      const equipmentId = action.payload.equipmentId || '';
      const siteId = action.payload.siteId || '';

      let copy = [...state.equipments];
      const findIndex = copy?.findIndex((equipment) => {
        return equipment.equipmentId === equipmentId;
      });
      if (findIndex >= 0) {
        copy[findIndex] = {
          ...copy[findIndex],
          notSHhowOnList: true,
          equipmentEditingStatus: ''
        };
        state.equipments = copy;
        let copySitesEquipmentsMap = { ...state.sitesEquipmentsMap };
        const selectedSitesEquipmentList = copySitesEquipmentsMap[siteId] || [];
        const newListAfterRemovedNewEquipment =
          selectedSitesEquipmentList?.filter((x) => x !== equipmentId) || [];

        copySitesEquipmentsMap[siteId] = newListAfterRemovedNewEquipment;
        state.sitesEquipmentsMap = copySitesEquipmentsMap;
      }
    },

    setEquipments1: (state, action) => {
      state.equipments = [...state.equipments, ...action.payload];
    },

    updateExistingEquipments: (state, action) => {
      const copy = [...state.equipments];

      const findIndexOfUpdatedEquipment = copy.findIndex(
        (equipment) => equipment.equipmentId === action.payload.equipmentId
      );

      copy[findIndexOfUpdatedEquipment] = {
        ...copy[findIndexOfUpdatedEquipment],
        ...action.payload
      };
      state.equipments = [...copy];
    },
    updateEquipmentWithFailedStatus: (state, action) => {
      const { equipmentId } = action.payload;
      const copy = [...state.equipments];

      const findIndexOfUpdatedEquipment = copy.findIndex(
        (equipment) => equipment.equipmentId === equipmentId
      );

      copy[findIndexOfUpdatedEquipment] = {
        ...copy[findIndexOfUpdatedEquipment],
        failedTask: true
      };
      state.equipments = [...copy];
    },

    setStartTaskCoordinates: (state, action) => {
      const { coordinates } = action.payload;
      state.startTaskCoordinates = coordinates;
    }
  }
});

const cacheReducer = cacheSlice.reducer;

export const cacheActions = cacheSlice.actions;
export default cacheReducer;

export const sitesMobileData = (sitePayloadData = [], state) => {
  const arr = [];
  let { unit = 'km', coordinates } = state;
  let sites = sitePayloadData;

  const sitesMap = sites.reduce((acc, curr, currIndex) => {
    const { siteId } = curr;
    acc[siteId] = currIndex;
    return acc;
  }, {});

  for (const key in sitesMap) {
    let distance = null;
    const { latitude, longitude } = sites[sitesMap[key]] || {};
    if (unit && coordinates && latitude !== null && longitude !== null)
      distance = getDistance({
        unit,
        from: coordinates,
        to: { longitude, latitude }
      });

    const index = sitesMap[key];
    const data = {
      ...sites[index],
      unit,
      distance: _.isNaN(distance) ? null : distance,
      children: [],
      index: index
    };
    arr.push(data);
  }

  arr.forEach((data) => {
    if (Object.hasOwnProperty.call(sitesMap, data.siteId)) {
      const { parentSiteId } = data;

      const parentSiteIndex = arr.findIndex((d) => d.siteId === parentSiteId);

      if (parentSiteIndex) arr[parentSiteIndex]?.children.push(data?.index);
    }
  });

  return {
    sites: arr,
    sitesMap
  };
};
